/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RouteNames from '../../RouteNames';

import MfaEnabled from './MfaEnabled';
import { getLoggedInUser } from '../../redux/reduxSelectors';
import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';
import { EnableMfaFlowActions } from '../../redux/userFlowActions';
import NavigationActions from '../../redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  const user = getLoggedInUser(state);
  const countryData = listSelectors.getCountryCollection(state).filter((c) => c.iso2 === user.data.iso2_code)[0] || {
    key: ' ',
  };

  return {
    isMfaEnabled: user.isMfaEnabled(),
    mobileNumber: user.data.mobile_number || '',
    countryCodeKey: countryData.key,

    loadInitialData: () => {},

    goBack: () => {
      NavigationActions.goBackTo(routerProps.history, RouteNames.accountSettings());
    },
    disableMfa: () => {
      EnableMfaFlowActions.disableMfa(() => {
        NavigationActions.goBackTo(routerProps.history, RouteNames.accountSettings());
      });
    },
  };
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submitMfaCode: EnableMfaFlowActions.enableMfa,
    onChangeMfaCode: EnableMfaFlowActions.mfaCode,
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(MfaEnabled);
